import React from "react";
import "./GrievanceRedressal.css";

const escalationRows = [
  {
    level: "First Escalation",
    designation: "Customer care",
    contact: (
      <>
        <strong>Phone:</strong>{" "}
        <a href="tel:+917338437609">+91 7338437609</a>
        <br />
        <strong>Email:</strong>{" "}
        <a href="mailto:customersupport@qualoan.com">customersupport@qualoan.com</a>
      </>
    ),
    policy:
      "If the issue is not resolved within 7 days of raising the issue, the customer shall raise the issue with the Grievance Officer",
  },
  {
    level: "Second Escalation",
    designation: "Grievance Officer",
    contact: (
      <>
        <strong>Name:</strong> Anuradha
        <br />
        <strong>Phone:</strong>{" "}
        <a href="tel:+917303044482">+91 7303044482</a>
        <br />
        <strong>Email:</strong>{" "}
        <a href="mailto:nodalofficer@namanfinlease.com">nodalofficer@namanfinlease.com</a>
      </>
    ),
    policy:
      "If the issue is not resolved within 7 days of raising the issue, the customer shall raise the further issue with the Nodal Officer",
  },
  {
    level: "Third Escalation",
    designation: "Nodal Officer",
    contact: (
      <>
        <strong>Name:</strong> Rajeev Ranjan
        <br />
        <strong>Phone:</strong>{" "}
        <a href="tel:+919990831500">+91 9990831500</a>
        <br />
        <strong>Email:</strong>{" "}
        <a href="mailto:nodalofficer@namanfinlease.com">nodalofficer@namanfinlease.com</a>
      </>
    ),
    policy: "",
  },
];

const GrievanceRedressal = () => (
  <div className="grievance-page">
    <section className="grievance-hero">
      <p className="grievance-eyebrow">RBI COMPLIANCE</p>
      <h1>Grievance Redressal Mechanism</h1>
      <p className="grievance-hero-subtitle">
        Our structured escalation process to ensure fair and timely resolution of your concerns.
      </p>
    </section>

    <section className="grievance-table-section">
      <div className="grievance-table-wrapper">
        <table className="grievance-table">
          <thead>
            <tr>
              <th>Escalation Level</th>
              <th>Designation</th>
              <th>Contact Details</th>
              <th>Escalation Policy</th>
            </tr>
          </thead>
          <tbody>
            {escalationRows.map((row) => (
              <tr key={row.level}>
                <td data-label="Escalation Level">{row.level}</td>
                <td data-label="Designation">{row.designation}</td>
                <td data-label="Contact Details">{row.contact}</td>
                <td data-label="Escalation Policy">{row.policy}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  </div>
);

export default GrievanceRedressal;
